module.exports = __webpack_public_path__ + "static/media/glutamine.93a9b2a4.svg";